export default __webpack_public_path__ + "static/media/Ilustraciya_investor-exit.510031a0.svg";